import React from "react";

import { ReactComponent as MenuSetting } from "assets/images/svg/menu-setting.svg?react";
import { ReactComponent as MenuStorageReturn } from "assets/images/svg/menu-storage-return.svg?react";
import { ReactComponent as MenuCast } from "assets/images/svg/menu-cast.svg?react";
import { ReactComponent as MenuOrderCreate } from "assets/images/svg/menu-order-create.svg?react";
import { ReactComponent as MenuStorageTransfer } from "assets/images/svg/menu-storage-transfer.svg?react";
import { ReactComponent as MenuStorageComing } from "assets/images/svg/menu-storage-coming.svg?react";
import { ReactComponent as MenuStorageWriteOff } from "assets/images/svg/menu-storage-write-off.svg?react";
import { ReactComponent as MenuAnalytics } from "assets/images/svg/menu-analiytics.svg?react";
import { ReactComponent as MenuFinance } from "assets/images/svg/menu-finance.svg?react";
import { ReactComponent as MenuReport } from "assets/images/svg/menu-report.svg?react";
import { ReactComponent as MenuHr } from "assets/images/svg/menu-hr.svg?react";
import { ReactComponent as MenuStorage } from "assets/images/svg/menu-storage.svg?react";
import { ReactComponent as MenuHandbook } from "assets/images/svg/menu-handbook.svg?react";
import { ReactComponent as MenuAccounting } from "assets/images/svg/menu-accounting.svg?react";
import { ReactComponent as ArrowRight } from "assets/images/svg/arrow-right.svg?react";
import { ReactComponent as LogoutOutlined } from "assets/images/svg/logout-outlined.svg?react";
import { ReactComponent as MenuCustomers } from "assets/images/svg/menu-customers.svg?react";
import { ReactComponent as MenuOrder } from "assets/images/svg/menu-order.svg?react";
import { ReactComponent as PrintIcon } from "assets/images/icons/icon-printer.svg?react";
import { ReactComponent as LockIcon } from "assets/images/svg/lock-icon.svg?react";
import { ReactComponent as MenuClients } from "assets/images/svg/menu-clients.svg?react";
import { ReactComponent as StoreIcon } from "assets/images/icons/store.svg?react";

const icons = {
  store: StoreIcon,
  "menu-setting": MenuSetting,
  "menu-storage-write-off": MenuStorageWriteOff,
  "menu-order-create": MenuOrderCreate,
  "menu-storage-coming": MenuStorageComing,
  "menu-storage-transfer": MenuStorageTransfer,
  "menu-storage-return": MenuStorageReturn,
  "menu-cast": MenuCast,
  "menu-analytic": MenuAnalytics,
  "menu-finance": MenuFinance,
  "menu-report": MenuReport,
  "menu-order": MenuOrder,
  "menu-customer": MenuCustomers,
  "menu-hr": MenuHr,
  "menu-clients": MenuClients,
  "menu-storage": MenuStorage,
  "menu-handbook": MenuHandbook,
  "menu-accounting": MenuAccounting,
  "lock-icon": LockIcon,
  "print-icon": PrintIcon,
  "arrow-right": ArrowRight,
  "logout-outlined": LogoutOutlined,
};

export const Icon = ({ icon, ...restProps }) => {
  const SVG = icons[icon];

  return <SVG {...restProps} />;
};
